import {TextModel} from "models/Text"
import React from "react"
import {FiltersPanelContainer, PaddedWrapper} from "../components"
import ShowFiltersText from "../showFiltersText"

export interface NoOptionsProps {
    text: TextModel
}

const NoOptionsText = ({text}: NoOptionsProps) => (
    <FiltersPanelContainer data-testid="plp-tabbed-facets-panel">
        <PaddedWrapper>
            <ShowFiltersText childtestid="plp-tabbed-facets-no-options">
                {text.labels.noOptionsAvailable}
            </ShowFiltersText>
        </PaddedWrapper>
    </FiltersPanelContainer>
)

export default NoOptionsText
